export default "__VITE_ASSET__BSA6fOuP__"